import * as React from 'react'; 

import { optimizedImage } from '../products/CroppedProductImage';
import PropTypes from 'prop-types';

import styles from './CategorySearchResults.module.css';

const CategorySearchHeader = ({
  heroImg,
  heroLbl
}) => {

  // in case the API doesn't have a category image
  const blankCategoryHero = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  const [categoryHero, setCategoryHero] = React.useState(blankCategoryHero);
  
  React.useEffect(() => {
    setCategoryHero(heroImg || blankCategoryHero);
  }, [heroImg]);

  return (
    <div className={styles.heroOuter}>
      <div className={styles.heroWrap}>
        <img className={styles.hero} alt={heroLbl} src={optimizedImage(categoryHero)} />
        <div className={styles.heroText}>{heroLbl}</div> 
      </div>
    </div>
  )
};

CategorySearchHeader.propTypes = {
  heroImg: PropTypes.string,
  heroLbl: PropTypes.string.isRequired
}

export default CategorySearchHeader